import './style/index.less';
import WxWorkLogin from './WxWorkLogin';

export default WxWorkLogin;
